const errors = {
  500: {
    DEFAULT:
      'Sucedio un error desconocido al realizar la petición al servidor. Por favor contacte a soporte.'
  },
  401: {
    DEFAULT: 'Debe estar autenticado para poder acceder a este recurso',
    AUTH_INVALID_CREDENTIALS: 'Usuario y/o contraseña incorrectos',
    AUTH_TOKEN_COMPROMISED:
      'Se han utilizado sus credenciales para iniciar sesión desde otro equipo.',
    AUTH_TOKEN_REVOKED:
      'Debe de autenticarse nuevamente para utilizar la plataforma.',
    AUTH_TOKEN_EXPIRED:
      'Su sesión ha expirado. Debe de autenticarse nuevamente para utilizar la plataforma.',
    AUTH_TOKEN_INVALID:
      'No reconocemos su sesión. Debe de autenticarse nuevamente para utilizar la plataforma.'
  },
  404: {
    DEFAULT: 'El recurso no fue encontrado',
    NOT_FOUND: 'No se encontró la petición en el servidor'
  },
  403: {
    YOU_CANT_TAKE_THIS_COURSE: 'No puedes tomar este curso.',
    NOT_ALLOWED: 'No cuentas con permisos para realizar esta acción.'
  },
  442: {
    DEFAULT: 'Existen errores de validación en la forma'
  },
  422: {
    DEFAULT: 'Existen errores de validación en la forma',
    'COURSE_ALREADY_REVIEWED': 'Ya has calificado este curso.'
  },
  429: {
    DEFAULT:
      'Ha excedido el numero de intentos, por favor espere un minuto e intente nuevamente.'
  },
  200: {
    DEFAULT: 'Operación realizada'
  },
  422: {
    DEFAULT: 'Existen errores de validación en la forma',
    'SAME_EMAIL': 'El correo electrónico es igual al correo electrónico registrado'
  },
  422: {
    DEFAULT: 'Existen errores de validación en la forma',
    'NOT_AUTHORIZED': 'No puede cambiar, actualizar o modificar información'
  },
  422: {
    DEFAULT: 'Existen errores de validación en la forma',
    'EMAIL_ALREADY_REGISTERED': 'El correo electrónico ya está registrado'
  }
}

const getError = (status, code = 'DEFAULT') => {
  const _status = errors[status] ? status : 500
  const _code = errors[_status][code] ? code : 'DEFAULT'
  return errors[_status][_code]
}

export default getError
